/**
 * @author zhengxinquan
 * @description  从api或缓存中获取授权的图片
 * @调用 await this.$store.dispatch('values/getValueList', 'SCHL.CHANNEL_TYPE');
 *             <el-option
              v-for="(item, index) in SCHL_SHOP_TYPE"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
 */
import { settingApi } from '@/api';
import { getEnvGlobalConfig } from '@/utils';
const DEFAULT_EXPIRES = 1 * 60 * 60;
const DEFAULT_BUCKET_NAME = getEnvGlobalConfig('VUE_APP_UPLOAD_BUCKET_NAME');
const getDefaultState = () => {
  return {
    FILES: [
      {
        bucketName: '',
        url: '',
        key: '',

        // new Date().getTime()/1000
        create: '', // 秒

        expires: '', // 秒
        fileTokenUrl: '', //
      },
    ],
  };
};
const state = getDefaultState();

const mutations = {
  ADD_FILES: (state, FILE) => {
    const index = state.FILES.findIndex(e => {
      if (FILE.url) {
        return e.bucketName == FILE.bucketName && e.url == FILE.url;
      }
      if (FILE.key) {
        return e.bucketName == FILE.bucketName && e.key == FILE.key;
      }
      return false;
    });
    if (index == -1) {
      state.FILES.push(FILE);
    } else {
      state.FILES.splice(index, 1, FILE);
    }
  },
};

// 用于存储正在进行中的请求，避免重复请求被取消
const pendingPromises = {};

const actions = {
  getFileTokenUrl({ commit, state }, { url, bucketName, expires }) {
    const EXPIRES = expires || DEFAULT_EXPIRES;
    const BUCKET_NAME = bucketName || DEFAULT_BUCKET_NAME;
    const URL = url;
    const finder_file = state.FILES.find(e => {
      const NOW_TIME = new Date().getTime() / 1000;
      const TIME_FLAG = e.create + e.expires > NOW_TIME;
      return e.bucketName == BUCKET_NAME && e.url == URL && TIME_FLAG;
    });

    if (finder_file) {
      return Promise.resolve(finder_file.fileTokenUrl);
    }

    // 使用请求锁，相同URL复用同一个Promise，避免重复请求被取消导致头像消失
    const cacheKey = `${BUCKET_NAME}_${URL}`;
    if (pendingPromises[cacheKey]) {
      return pendingPromises[cacheKey];
    }

    const promise = new Promise((resolve, reject) => {
      settingApi
        .getFileUrlByUrl({
          bucketName: BUCKET_NAME,
          url: URL,
          expires: EXPIRES,
        })
        .then(res => {
          if (res.failed !== true) {
            let url = res.fileTokenUrl || res.message || res;
            if (url.indexOf('http') !== 0) {
              url = 'http://' + url;
            }
            const FILE = {
              bucketName: BUCKET_NAME,
              url: URL,
              key: '',
              create: new Date().getTime() / 1000,
              expires: EXPIRES, // 秒
              fileTokenUrl: url,
            };
            commit('ADD_FILES', FILE);
            resolve(url);
          } else {
            reject(url);
          }
        })
        .catch(err => {
          reject(err);
        })
        .finally(() => {
          delete pendingPromises[cacheKey];
        });
    });

    pendingPromises[cacheKey] = promise;
    return promise;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
